$(document).ajaxComplete(function(){

  $(document).on('click','.product-form__submit',function(){

    if ($(".product-form .gpo-element").hasClass("has-error")) {
  $(".product-form .messages").css('display','block');
}else{
$(".product-form .messages").css('display','none');

}

  });

});

$(document).ready(function(){

  // if($(window).width() < 768){
  //   $( ".header__icons" ).insertAfter( $(".menu-drawer__menu.list-menu li:last-child"));
  // }

   $(document).on('click','.product-form__submit',function(){

    if ($(".product-form .gpo-element").hasClass("has-error")) {
  $(".product-form .messages").css('display','block');
}else{
$(".product-form .messages").css('display','none');

}

  });



  jQuery(document).on("click",".popup.show",function(e){

       e.stopPropagation();
       $(".popup").removeClass("show");


      // var player = $f(iframe);
      // var player = new Vimeo.Player(iframe);



var iframe = document.getElementById('popup_mobile');

    var iframe2 = document.getElementById('popup_desktop');
  // $f == Froogaloop
    // var player = $f(iframe);
    var player = new Vimeo.Player(iframe);

    // var player2 = $f(iframe2);
    var player2 = new Vimeo.Player(iframe2);


    player.pause();
    player2.pause();


      	/*var url = $(".popup iframe").attr('src');

      	$(".popup iframe").attr('src',url);
        */
  });



/*$(document).on('click',"#buttons-1_2",function(){
  setTimeout(function(){

 $("#select-1").val('2');
jQuery('[data-element-id="paragraph-5"]').attr("data-clo-display","hide");
jQuery('[data-element-id="buttons-4"]').attr("data-clo-display","hide");
   jQuery('[data-element-id="buttons-4"] input').removeAttr('disabled');

  },1000);


}); */






    jQuery(document).on("change",'[data-element-id="buttons-1"]  [data-type="buttons"]',function(){


     jQuery('[data-type="buttons"]').each(function(){

              jQuery(this).parent().css("pointer-events", "auto");

          if(jQuery(this).attr("previous-value") == "checked"){

              jQuery(this).parent().css("pointer-events", "none");

          }else if(jQuery(this).attr("previous-value") == "false"){

          }
     });
  });



  $(document).on("change","#select-1",function(){

jQuery('[value="Houndsy Kibble Dispenser Product"]').each(function(){
      if(jQuery(this).parent().parent().parent().attr("data-clo-display") == "hide"){

        if($(this).prop("checked") != true){
                    console.log("Checked");
                    jQuery(this).trigger("click")
         }else{
                    console.log("Unchecked");
         }
      }

});


});


});


jQuery(document).ready(function(){


         setTimeout(function () {

           jQuery('[data-element-id="buttons-1"] .gpo-swatches.buttons:first').attr("style","pointer-events: none;");
           console.log("Test");
           if(jQuery('[data-element-id="buttons-1"] .gpo-swatches.buttons:first').attr("style") == "pointer-events: none;"){
           	//return;
           }else{

           }


         }, 2000);





   setTimeout(function(){
  	jQuery('[data-element-id="buttons-1"] .gpo-swatches.buttons:first').attr("style","pointer-events: none;");
  },1000);

/* 
jQuery(document).on("click",".xzoom-thumbs a",function(ev){

  ev.preventDefault()
  
    jQuery("#xzoom-default").attr("src",this.getAttribute('href'));

    console.log(this.getAttribute('href'))

   if(jQuery("#xzoom-default").is(":hidden")){


     	  jQuery("#xzoom-default").removeClass("hide_zoom_default");
          // jQuery("#xzoom-default").attr("style","width:0px !important");
          jQuery("#xzoom-default").show();
     	  jQuery(this).trigger("click");

 		  console.log("Yaah");
  }else{


     //jQuery(".iframevido").attr("src","");
 	 jQuery(".iframevido").hide();
     jQuery(".iframevido").attr("src",jQuery(".iframevido").attr("src"));

  }


  /*
    if(jQuery("#xzoom-default").is(":hidden")){

    jQuery("#xzoom-default").attr("style","position:absolute;visibility:hidden");
    jQuery("#xzoom-default").show();
      setTimeout(function(){
		 jQuery("#xzoom-default").attr("style","");
       // jQuery("#xzoom-default").attr("style","");
      },1000);


     jQuery(".iframevido").hide();
     jQuery(".iframevido").attr("src",jQuery(".iframevido").attr("src"));

  }else{

  jQuery(".iframevido").hide();

  }
  
});*/
  /*
jQuery(document).on("click","#shopify-section-template--16708761256175__main > section > div > div.xzoom-container > div > a:nth-child(5)",function(){

     // jQuery(".xzoom-container").attr("style","pointer-events: none;")

  if(jQuery("#xzoom-default").is(":hidden")){



  }else{
    	jQuery("#xzoom-default").hide();
       jQuery(".iframevido").show();


    	//jQuery("#xzoom-default").attr("style","opacity:0;position:absolute");
    jQuery(".xzoom-source").hide();
    	//jQuery("#xzoom-default").hide();
      // jQuery("#xzoom-default").attr("opacity:0;position:absolute");
       jQuery("#xzoom-default").addClass("hide_zoom_default");

  }



});
*/
/*
jQuery(document).on("click",".custom-product__kibble .xzoom-container > div > a:nth-child(5)",function(){

     // jQuery(".xzoom-container").attr("style","pointer-events: none;")

  if(jQuery("#xzoom-default").is(":hidden")){



  }else{
    	jQuery("#xzoom-default").hide();
       jQuery(".iframevido").show();


    	//jQuery("#xzoom-default").attr("style","opacity:0;position:absolute");
    jQuery(".xzoom-source").hide();
    	//jQuery("#xzoom-default").hide();
      // jQuery("#xzoom-default").attr("opacity:0;position:absolute");
       jQuery("#xzoom-default").addClass("hide_zoom_default");

  }



});
  */
  /*
jQuery(document).on("click","#shopify-section-template--16700656517359__main > section > div > div.xzoom-container > div > a:nth-child(5)",function(){

     // jQuery(".xzoom-container").attr("style","pointer-events: none;")

  if(jQuery("#xzoom-default").is(":hidden")){



  }else{
    	jQuery("#xzoom-default").hide();
       jQuery(".iframevido").show();


    	//jQuery("#xzoom-default").attr("style","opacity:0;position:absolute");
    jQuery(".xzoom-source").hide();
    	//jQuery("#xzoom-default").hide();
      // jQuery("#xzoom-default").attr("opacity:0;position:absolute");
       jQuery("#xzoom-default").addClass("hide_zoom_default");

  }



});
*/



  $('.gpo-swatches #buttons-1_2').attr('data-ref','2');

  $('#select-1 option[value="2"]:selected');

    $(document).scroll(function() {
     if($(window).scrollTop() === 0) {
      jQuery(".hdr2").css("position","unset")
     }else if($(window).scrollTop() > 0){
  jQuery(".hdr2").css("position","fixed")
     }
  });

     if($(window).scrollTop() === 0) {
        jQuery(".hdr2").css("position","unset")
       }else if($(window).scrollTop() > 0){
    jQuery(".hdr2").css("position","fixed")
      }


    jQuery(function () {
        jQuery(".faq li:not(:first-child) .faq-ans").css("display", "none");

        jQuery(".faq li:nth-child(1) .faq-ques").addClass("open");

        jQuery(".faq li .faq-ques").click(function () {
            jQuery(".open").not(this).removeClass("open").next().slideUp(300);
        jQuery(this).toggleClass("open").next().slideToggle(300);
        });
    });

  	// $('.form__label').text("Message");

  	$('.product-form__submit span').text("Add to Cart");

  	$(".contact_main").parent().parent().addClass("contactcustomclass");

  	$(".hero_btn").click(function(){
      	$(".popup").addClass("show");
    });

  	$(".popup i").click(function(){
      	$(".popup").removeClass("show");
      	var url = $(".popup iframe").attr('src');
      	console.log(url);
      	//$(".popup iframe").attr('src',url);


      var iframe = document.getElementById('popup_mobile');

    var iframe2 = document.getElementById('popup_desktop');
  // $f == Froogaloop
    // var player = $f(iframe);
    var player = new Vimeo.Player(iframe);
    // var player2 = $f(iframe2);
    var player2 = new Vimeo.Player(iframe2);

    player.pause();
    player2.pause();

    });

  $(".hero_btn").click(function(){
    //$(".popup iframe").attr('src',' https://player.vimeo.com/video/646036727?h=250055e2a8');
  });

  $('.popup').click(function (e) {
    if (!$(e.target).parents().is('iframe')) {

     // $(".popup iframe").attr('src','0');
    }
});

//   Product Slider
  (function ($) {
$(document).ready(function() {
$('.xzoom, .xzoom-gallery').xzoom({zoomWidth: 400, title: true, tint: '#333', Xoffset: 15});
$('.xzoom2, .xzoom-gallery2').xzoom({position: '#xzoom2-id', tint: '#ffa200'});
$('.xzoom3, .xzoom-gallery3').xzoom({position: 'lens', lensShape: 'circle', sourceClass: 'xzoom-hidden'});
$('.xzoom4, .xzoom-gallery4').xzoom({tint: '#006699', Xoffset: 15});
$('.xzoom5, .xzoom-gallery5').xzoom({tint: '#006699', Xoffset: 15});

//Integration with hammer.js
var isTouchSupported = 'ontouchstart' in window;

if (isTouchSupported) {
//If touch device
$('.xzoom, .xzoom2, .xzoom3, .xzoom4, .xzoom5').each(function(){
var xzoom = $(this).data('xzoom');
xzoom.eventunbind();
});

$('.xzoom, .xzoom2, .xzoom3').each(function() {
var xzoom = $(this).data('xzoom');
$(this).hammer().on("tap", function(event) {
event.pageX = event.gesture.center.pageX;
event.pageY = event.gesture.center.pageY;
var s = 1, ls;

xzoom.eventmove = function(element) {
element.hammer().on('drag', function(event) {
event.pageX = event.gesture.center.pageX;
event.pageY = event.gesture.center.pageY;
xzoom.movezoom(event);
event.gesture.preventDefault();
});
}

xzoom.eventleave = function(element) {
element.hammer().on('tap', function(event) {
xzoom.closezoom();
});
}
xzoom.openzoom(event);
});
});

$('.xzoom4').each(function() {
var xzoom = $(this).data('xzoom');
$(this).hammer().on("tap", function(event) {
event.pageX = event.gesture.center.pageX;
event.pageY = event.gesture.center.pageY;
var s = 1, ls;

xzoom.eventmove = function(element) {
element.hammer().on('drag', function(event) {
event.pageX = event.gesture.center.pageX;
event.pageY = event.gesture.center.pageY;
xzoom.movezoom(event);
event.gesture.preventDefault();
});
}

var counter = 0;
xzoom.eventclick = function(element) {
element.hammer().on('tap', function() {
counter++;
if (counter == 1) setTimeout(openfancy,300);
event.gesture.preventDefault();
});
}

function openfancy() {
if (counter == 2) {
xzoom.closezoom();
$.fancybox.open(xzoom.gallery().cgallery);
} else {
xzoom.closezoom();
}
counter = 0;
}
xzoom.openzoom(event);
});
});

$('.xzoom5').each(function() {
var xzoom = $(this).data('xzoom');
$(this).hammer().on("tap", function(event) {
event.pageX = event.gesture.center.pageX;
event.pageY = event.gesture.center.pageY;
var s = 1, ls;

xzoom.eventmove = function(element) {
element.hammer().on('drag', function(event) {
event.pageX = event.gesture.center.pageX;
event.pageY = event.gesture.center.pageY;
xzoom.movezoom(event);
event.gesture.preventDefault();
});
}

var counter = 0;
xzoom.eventclick = function(element) {
element.hammer().on('tap', function() {
counter++;
if (counter == 1) setTimeout(openmagnific,300);
event.gesture.preventDefault();
});
}

function openmagnific() {
if (counter == 2) {
xzoom.closezoom();
var gallery = xzoom.gallery().cgallery;
var i, images = new Array();
for (i in gallery) {
images[i] = {src: gallery[i]};
}
$.magnificPopup.open({items: images, type:'image', gallery: {enabled: true}});
} else {
xzoom.closezoom();
}
counter = 0;
}
xzoom.openzoom(event);
});
});

} else {
//If not touch device

//Integration with fancybox plugin
$('#xzoom-fancy').bind('click', function(event) {
var xzoom = $(this).data('xzoom');
xzoom.closezoom();
$.fancybox.open(xzoom.gallery().cgallery, {padding: 0, helpers: {overlay: {locked: false}}});
event.preventDefault();
});

//Integration with magnific popup plugin
$('#xzoom-magnific').bind('click', function(event) {
var xzoom = $(this).data('xzoom');
xzoom.closezoom();
var gallery = xzoom.gallery().cgallery;
var i, images = new Array();
for (i in gallery) {
images[i] = {src: gallery[i]};
}
$.magnificPopup.open({items: images, type:'image', gallery: {enabled: true}});
event.preventDefault();
});
}
});
})(jQuery);


});

$(document).ready(function(){

  $("#product-form-template--15443530219759__main").validate({
      focusInvalid: false,
      invalidHandler: function(form, validator) {
		alert('asd');
          if (!validator.numberOfInvalids())
              return;

          $('html, body').animate({
              scrollTop: $(validator.errorList[0].element).offset().top
          }, 2000);

      }
  });

});
